/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as GroupDefs from '../group/defs.defs.js'
import * as ConvoDefs from '../convo/defs.defs.js'

const $nsid = 'chat.bsky.moderation.defs'

export { $nsid }

/** A view of a conversation for moderation purposes. Unlike chat.bsky.convo.defs#convoView, it does not include viewer-specific data (such as muted, unreadCount, status, lastMessage, lastReaction), since the requester is a moderator and not a member of the conversation. The member list is not included; use chat.bsky.moderation.getConvoMembers to list members. */
type ConvoView = {
  $type?: 'chat.bsky.moderation.defs#convoView'
  id: string
  rev: string

  /**
   * Union field that has data specific to different kinds of convos.
   */
  kind?: l.$Typed<DirectConvo> | l.$Typed<GroupConvo> | l.Unknown$TypedObject
}

export type { ConvoView }

/** A view of a conversation for moderation purposes. Unlike chat.bsky.convo.defs#convoView, it does not include viewer-specific data (such as muted, unreadCount, status, lastMessage, lastReaction), since the requester is a moderator and not a member of the conversation. The member list is not included; use chat.bsky.moderation.getConvoMembers to list members. */
const convoView = /*#__PURE__*/ l.typedObject<ConvoView>(
  $nsid,
  'convoView',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.string(),
    rev: /*#__PURE__*/ l.string(),
    kind: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<DirectConvo>((() => directConvo) as any),
          /*#__PURE__*/ l.typedRef<GroupConvo>((() => groupConvo) as any),
        ],
        false,
      ),
    ),
  }),
)

export { convoView }

/** Data specific to a direct conversation, for moderation purposes. */
type DirectConvo = { $type?: 'chat.bsky.moderation.defs#directConvo' }

export type { DirectConvo }

/** Data specific to a direct conversation, for moderation purposes. */
const directConvo = /*#__PURE__*/ l.typedObject<DirectConvo>(
  $nsid,
  'directConvo',
  /*#__PURE__*/ l.object({}),
)

export { directConvo }

/** Data specific to a group conversation, for moderation purposes. Unlike chat.bsky.convo.defs#groupConvo, it does not include viewer-specific data (such as unreadJoinRequestCount), since the requester is a moderator and not a member of the conversation. */
type GroupConvo = {
  $type?: 'chat.bsky.moderation.defs#groupConvo'
  createdAt: l.DatetimeString
  joinLink?: GroupDefs.JoinLinkView

  /**
   * The total number of pending join requests for the group conversation. This information is only visible to the owner and to moderators. Capped at 21.
   */
  joinRequestCount: number

  /**
   * The lock status of the conversation.
   */
  lockStatus: ConvoDefs.ConvoLockStatus

  /**
   * The total number of members in the group conversation.
   */
  memberCount: number

  /**
   * The maximum number of members allowed in the group conversation.
   */
  memberLimit: number

  /**
   * The display name of the group conversation.
   */
  name: string
}

export type { GroupConvo }

/** Data specific to a group conversation, for moderation purposes. Unlike chat.bsky.convo.defs#groupConvo, it does not include viewer-specific data (such as unreadJoinRequestCount), since the requester is a moderator and not a member of the conversation. */
const groupConvo = /*#__PURE__*/ l.typedObject<GroupConvo>(
  $nsid,
  'groupConvo',
  /*#__PURE__*/ l.object({
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    joinLink: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<GroupDefs.JoinLinkView>(
        (() => GroupDefs.joinLinkView) as any,
      ),
    ),
    joinRequestCount: /*#__PURE__*/ l.integer(),
    lockStatus: /*#__PURE__*/ l.ref<ConvoDefs.ConvoLockStatus>(
      (() => ConvoDefs.convoLockStatus) as any,
    ),
    memberCount: /*#__PURE__*/ l.integer(),
    memberLimit: /*#__PURE__*/ l.integer(),
    name: /*#__PURE__*/ l.string({ maxGraphemes: 50, maxLength: 500 }),
  }),
)

export { groupConvo }
